import * as React from 'react'
import { Button } from 'antd'

interface Props {
  id: string
  quantity: number
  lowStockQuantity?: number
  showLowStockQuantity: boolean
  onClick: () => void
}

export class InventoryBadge extends React.Component<Props, {}> {
  render() {
    const { quantity, lowStockQuantity, showLowStockQuantity } = this.props

    const lowStockQuantityString = lowStockQuantity === null ? '-' : lowStockQuantity

    return (
      <>
        <Button
          type='link'
          id={this.props.id}
          className='pr-0 text-right'
          style={{ width: '100px' }}
        >
          <span style={{ color: '#495057', fontSize: '1.5em' }}>
            {parseFloat(quantity.toFixed(2))}
          </span>
        </Button>
        <div style={{ textAlign: 'right' }}>
          {showLowStockQuantity && <span className='text-muted'>Low {lowStockQuantityString}</span>}
        </div>
      </>
    )
  }
}
